import { render, staticRenderFns } from "./TemporaryPage.vue?vue&type=template&id=24cc1520&scoped=true"
import script from "./TemporaryPage.vue?vue&type=script&lang=js"
export * from "./TemporaryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cc1520",
  null
  
)

export default component.exports